/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annual_Promo_DescriptionInputs */

const en_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save ~17% by moving your monthly subscription into an annual payment. Get started by clicking "<strong>Switch to annual</strong>" in your subscription details.`)
};

const id_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemat ~17% dengan mengubah langganan bulanan Anda menjadi pembayaran tahunan. Mulailah dengan mengeklik "<strong>Beralih ke tahunan</strong>" di detail langganan Anda.`)
};

const ms_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jimat ~17% dengan menukar langganan bulanan anda kepada bayaran tahunan. Mulakan dengan mengklik "<strong>Tukar kepada tahunan</strong>" dalam butiran langganan anda.`)
};

const ca_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estalvia ~17% movent la teva subscripció mensual a un pagament anual. Comença fent clic a "<strong>Canvia a anual</strong>" als detalls de la teva subscripció.`)
};

const cs_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ušetřete ~17 % převodem svého měsíčního předplatného na roční platbu. Začněte kliknutím na „<strong>Přejít na roční</strong>“ v podrobnostech předplatného.`)
};

const da_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar ~17 % ved at flytte dit månedlige abonnement til en årlig betaling. Kom i gang ved at klikke på "<strong>Skift til årlig</strong>" i dine abonnementsdetaljer.`)
};

const de_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparen Sie rund 17 %, indem Sie Ihr Monatsabo auf ein Jahresabo umstellen. Klicken in Ihren Abonnementdetails einfach auf <strong>Auf Jahresabo umstellen</strong>, um loszulegen.`)
};

const et_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästa ~17%, viies oma kuutellimuse üle aastasele maksele. Alusta, klõpsates oma tellimuse üksikasjades nupul "<strong>Lülitu aastasele</strong>".`)
};

const es_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra ~17 % al cambiar tu suscripción mensual a un pago anual. Comienza haciendo clic en "<strong>Cambiar a anual</strong>" en los detalles de tu suscripción.`)
};

const fr_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économisez environ 17 % en optant pour un abonnement annuel ! Cliquez sur « <strong>Passer à l’abonnement annuel</strong> » dans les détails de votre abonnement.`)
};

const hr_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uštedite ~17% prebacivanjem mjesečne pretplate na godišnje plaćanje. Započnite klikom na "<strong>Prebaci na godišnje</strong>" u detaljima vaše pretplate.`)
};

const it_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia il ~17% passando da un abbonamento mensile a un abbonamento annuale. Fai clic su "<strong>Passa ad annuale</strong>" nei dettagli del tuo abbonamento.`)
};

const lv_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ietaupiet ~17%, pārvēršot ikmēneša abonementu gada maksājumā. Lai sāktu, noklikšķiniet uz "<strong>Pārslēgties uz gada plānu</strong>" abonementa informācijā.`)
};

const lt_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sutaupykite ~17 %, pakeisdami mėnesinę prenumeratą į metinį mokėjimą. Pradėkite spustelėdami „<strong>Pereiti prie metinio</strong>“ savo prenumeratos informacijoje.`)
};

const hu_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spórolj ~17%-ot azzal, hogy havi előfizetésedet éves fizetésre váltod. A kezdéshez kattints a „<strong>Váltás évesre</strong>” lehetőségre az előfizetés részleteinél.`)
};

const nl_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespaar ~17% door je maandelijkse abonnement om te zetten naar een jaarlijkse betaling. Ga aan de slag door op "<strong>Overstappen naar jaarlijks</strong>" te klikken in je abonnementsgegevens.`)
};

const nb_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spar ~17 % ved å gjøre om månedsabonnementet ditt til en årlig betaling. Kom i gang ved å klikke på «<strong>Bytt til årlig</strong>» i abonnementsdetaljene dine.`)
};

const pl_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oszczędź ~17%, zmieniając miesięczną subskrypcję na płatność roczną. Aby rozpocząć, kliknij "<strong>Przełącz na roczną</strong>" w szczegółach subskrypcji.`)
};

const pt_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economize 17% transformando sua assinatura mensal em anual. Comece clicando em "<strong>Mudar para anual</strong>" nos detalhes da sua assinatura.`)
};

const ro_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economisește ~17% prin trecerea abonamentului lunar la o plată anuală. Începe făcând clic pe „<strong>Treci la anual</strong>” în detaliile abonamentului tău.`)
};

const sk_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ušetrite ~17 % prepnutím mesačného predplatného na ročnú platbu. Začnite kliknutím na „<strong>Prepnúť na ročné</strong>“ v detailoch vášho predplatného.`)
};

const sl_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prihranite ~17 % tako, da svojo mesečno naročnino preklopite na letno plačilo. Začnite tako, da v podrobnostih naročnine kliknete »<strong>Preklopi na letno</strong>«.`)
};

const fi_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säästä ~17 % siirtämällä kuukausitilauksesi vuosimaksuksi. Aloita napsauttamalla "<strong>Vaihda vuositilaukseen</strong>" tilauksesi tiedoissa.`)
};

const sv_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara ~17 % genom att flytta din månadsprenumeration till en årlig betalning. Kom igång genom att klicka på "<strong>Byt till årsvis</strong>" i dina prenumerationsuppgifter.`)
};

const vi_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiết kiệm ~17% bằng cách chuyển đăng ký hàng tháng của bạn sang thanh toán hàng năm. Bắt đầu bằng cách nhấp vào "<strong>Chuyển sang hàng năm</strong>" trong chi tiết đăng ký của bạn.`)
};

const tr_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık aboneliğinizi yıllık ödemeye geçirerek ~%17 tasarruf edin. Başlamak için abonelik ayrıntılarınızdaki "<strong>Yıllığa geç</strong>" seçeneğine tıklayın.`)
};

const el_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξοικονομήστε ~17% μετατρέποντας τη μηνιαία συνδρομή σας σε ετήσια πληρωμή. Ξεκινήστε κάνοντας κλικ στο "<strong>Μετάβαση σε ετήσια</strong>" στις λεπτομέρειες της συνδρομής σας.`)
};

const bg_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спестете ~17%, като преминете от месечен към годишен абонамент. Започнете, като щракнете върху „<strong>Преминаване към годишен</strong>“ в детайлите на абонамента си.`)
};

const ru_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экономьте ~17%, переведя ежемесячную подписку на ежегодную оплату. Чтобы начать, нажмите «<strong>Перейти на ежегодную</strong>» в данных вашей подписки.`)
};

const sr_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уштедите ~17% преласком са месечне претплате на годишње плаћање. Започните кликом на „<strong>Пређи на годишњу</strong>“ у детаљима ваше претплате.`)
};

const uk_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Економте ~17%, перевівши щомісячну підписку на річний платіж. Щоб почати, натисніть «<strong>Перейти на річну</strong>» у деталях вашої підписки.`)
};

const ka_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაზოგეთ ~17% თქვენი ყოველთვიური გამოწერის წლიურ გადახდაზე გადატანით. დასაწყებად დააწკაპუნეთ "<strong>გადართვა წლიურზე</strong>" თქვენი გამოწერის დეტალებში.`)
};

const hi_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी मासिक सदस्यता को वार्षिक भुगतान में स्थानांतरित करके ~17% बचाएं। शुरू करने के लिए अपने सदस्यता विवरण में "<strong>वार्षिक पर स्विच करें</strong>" पर क्लिक करें।`)
};

const th_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประหยัด ~17% โดยเปลี่ยนการสมัครสมาชิกรายเดือนของคุณเป็นการชำระเงินรายปี เริ่มต้นโดยคลิก "<strong>เปลี่ยนเป็นรายปี</strong>" ในรายละเอียดการสมัครสมาชิกของคุณ`)
};

const ko_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간 구독을 연간 결제로 전환하여 최대 17%를 절약하세요. 구독 세부 정보에서 "<strong>연간 결제로 전환</strong>"을 클릭하여 시작하세요.`)
};

const zh_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将您的月度订阅更改为年度订阅可享受 2 个月的免费订阅。在订阅详情中点击<strong>切换为年度订阅</strong>即可更改。`)
};

const zh_tw_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`將您的每月訂閱改為年付，可省下約 17%。請在訂閱詳細資訊中點擊「<strong>切換至年付</strong>」即可開始。`)
};

const ja_annual_promo_description = /** @type {(inputs: Annual_Promo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月額サブスクリプションを年額支払いに変更することで約17%節約できます。サブスクリプションの詳細で「<strong>年額に切り替える</strong>」をクリックして開始してください。`)
};

/**
* | output |
* | --- |
* | "Save ~17% by moving your monthly subscription into an annual payment. Get started by clicking \"<strong>Switch to annual</strong>\" in your subscription details." |
*
* @param {Annual_Promo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_promo_description = /** @type {((inputs?: Annual_Promo_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_Promo_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_promo_description(inputs)
	if (locale === "ms") return ms_annual_promo_description(inputs)
	if (locale === "ca") return ca_annual_promo_description(inputs)
	if (locale === "cs") return cs_annual_promo_description(inputs)
	if (locale === "da") return da_annual_promo_description(inputs)
	if (locale === "de") return de_annual_promo_description(inputs)
	if (locale === "et") return et_annual_promo_description(inputs)
	if (locale === "es") return es_annual_promo_description(inputs)
	if (locale === "fr") return fr_annual_promo_description(inputs)
	if (locale === "hr") return hr_annual_promo_description(inputs)
	if (locale === "it") return it_annual_promo_description(inputs)
	if (locale === "lv") return lv_annual_promo_description(inputs)
	if (locale === "lt") return lt_annual_promo_description(inputs)
	if (locale === "hu") return hu_annual_promo_description(inputs)
	if (locale === "nl") return nl_annual_promo_description(inputs)
	if (locale === "nb") return nb_annual_promo_description(inputs)
	if (locale === "pl") return pl_annual_promo_description(inputs)
	if (locale === "pt") return pt_annual_promo_description(inputs)
	if (locale === "ro") return ro_annual_promo_description(inputs)
	if (locale === "sk") return sk_annual_promo_description(inputs)
	if (locale === "sl") return sl_annual_promo_description(inputs)
	if (locale === "fi") return fi_annual_promo_description(inputs)
	if (locale === "sv") return sv_annual_promo_description(inputs)
	if (locale === "vi") return vi_annual_promo_description(inputs)
	if (locale === "tr") return tr_annual_promo_description(inputs)
	if (locale === "el") return el_annual_promo_description(inputs)
	if (locale === "bg") return bg_annual_promo_description(inputs)
	if (locale === "ru") return ru_annual_promo_description(inputs)
	if (locale === "sr") return sr_annual_promo_description(inputs)
	if (locale === "uk") return uk_annual_promo_description(inputs)
	if (locale === "ka") return ka_annual_promo_description(inputs)
	if (locale === "hi") return hi_annual_promo_description(inputs)
	if (locale === "th") return th_annual_promo_description(inputs)
	if (locale === "ko") return ko_annual_promo_description(inputs)
	if (locale === "zh") return zh_annual_promo_description(inputs)
	if (locale === "zh-tw") return zh_tw_annual_promo_description(inputs)
	if (locale === "ja") return ja_annual_promo_description(inputs)
	return en_annual_promo_description(inputs)
});